import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { addAddon, removeAddon } from "areas/cart/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"

import { AddonItem, QtyIcon } from "../components"

import AddonPrice from "./addon-price"

const InternalAddonMobile = ({
  addon,
  addExclusiveAddon,
  disableActions,
  removeExclusiveAddon,
  selectedAddons,
  setAddonInModal,
  toggleAddonModal,
}) => {
  const adding =
    disableActions.id === addon.code && disableActions.action === "adding"
  const removing =
    disableActions.id ===
      (selectedAddons[addon.code] && selectedAddons[addon.code].id) &&
    disableActions.action === "removing"

  const addonContent = (
    <>
      <div className="border-grey-20 rounded-t-md border bg-white px-1 pt-3">
        <Image
          alt={addon.title}
          className="mb-3"
          height="138px"
          src={addon.images[0]}
          width="138px"
        />
        <AddonPrice price={addon.price} retail_price={addon.retail_price} />
      </div>
      <div className="bg-black-print flex w-full items-center justify-center gap-8 rounded-b-md py-8 text-white">
        {!selectedAddons[addon.code] && !adding ? (
          <p className="text-16 leading-16 font-medium">+ Add</p>
        ) : (
          <>
            <QtyIcon
              className="text-14 text-white"
              data-cy="cart-addon-minus-btn-mobile"
              disabled={disableActions.id !== ""}
              onClick={() => {
                if (disableActions.id === "") {
                  removeExclusiveAddon(selectedAddons[addon.code].id)
                }
              }}
            >
              <FontAwesomeIcon
                icon={removing ? faSpinner : faMinus}
                spin={removing}
              />
            </QtyIcon>
            <p
              className="text-16 tracking-tightest leading-14 font-bold"
              data-cy="cart-addon-qty-mobile"
            >
              {selectedAddons[addon.code]
                ? selectedAddons[addon.code].quantity
                : 0}
            </p>
            <QtyIcon
              className="text-14 text-white"
              data-cy="cart-addon-plus-btn-mobile"
              disabled={disableActions.id !== ""}
              onClick={() => {
                if (disableActions.id === "") {
                  addExclusiveAddon(addon.code, addon.type)
                }
              }}
            >
              <FontAwesomeIcon
                icon={adding ? faSpinner : faPlus}
                spin={adding}
              />
            </QtyIcon>
          </>
        )}
      </div>
    </>
  )

  return (
    <AddonItem className="max-w-140 mb-8 mt-20 shrink-0 grow-0 basis-1/2">
      {!selectedAddons[addon.code] && !adding && !removing ? (
        <Button
          className="block rounded-md focus:-outline-offset-2"
          data-cy="cart-addon-mobile"
          disabled={adding || removing}
          onClick={() => {
            setAddonInModal(addon)
            toggleAddonModal(true)
          }}
        >
          {addonContent}
        </Button>
      ) : (
        addonContent
      )}
    </AddonItem>
  )
}

/**
 * Get "BUNDLE" addons with quantity
 *
 * @return {obj} - {GIFTCRSN: {quantity: 2, ...<other addon proeprties>}}
 */
const getSelectedAddons = (addons) => {
  return (addons || [])
    .filter((a) => a.addon_type === "BUNDLE" || a.addon_type === "GIFT_CARD")
    .reduce(
      (acum, addon) =>
        Object.assign(acum, {
          [addon.addon_code]: {
            quantity: acum[addon.addon_code]
              ? acum[addon.addon_code].quantity + 1
              : 1,
            ...addon,
          },
        }),
      {}
    )
}

const mapStateToProps = (state) => {
  return {
    selectedAddons: getSelectedAddons(state.cart.addons),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addExclusiveAddon: (addonCode, addon_type) => {
      // addAddon from cart_mobile
      dispatch(
        addAddon(
          addonCode,
          addon_type,
          "cart_mobile",
          ownProps.toggleDisableActions
        )
      )
    },
    removeExclusiveAddon: (addonId) => {
      dispatch(removeAddon(addonId, ownProps.toggleDisableActions))
    },
  }
}

InternalAddonMobile.propTypes = {
  addExclusiveAddon: PropTypes.func,
  addon: PropTypes.object,
  disableActions: PropTypes.object,
  removeExclusiveAddon: PropTypes.func,
  selectedAddons: PropTypes.object,
  setAddonInModal: PropTypes.func,
  toggleAddonModal: PropTypes.func,
  toggleDisableActions: PropTypes.func,
}

const AddonMobile = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAddonMobile)

export default AddonMobile
